import React, { useCallback, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import DropDownButton from 'devextreme-react/drop-down-button';

import AntLocalization from '../../utils/AntLocalization';
import AntAuth from '../../utils/AntAuth';
import AntQuickCreate from '../../utils/AntQuickCreate';
import AntMessageBox from '../AntMessageBox';
import { AntGlobal } from '../../utils/AntContext';

// Nút "+" Thêm nhanh của chế độ Kế toán (TQ-04): mục lấy từ appGlobal.accountingQuickCreate (ante-web khai, nhãn 10
// ngôn ngữ ngay trong mục — không tra field config web). Chỉ vẽ ở chế độ Kế toán và khi còn ít nhất một mục hiện.
const HINT = { vi: 'Thêm nhanh', en: 'Quick add', fr: 'Ajout rapide', es: 'Añadir rápido', id: 'Tambah cepat', ja: 'クイック追加', zh: '快速新增', ko: '빠른 추가', hi: 'त्वरित जोड़ें', ar: 'إضافة سريعة' };
const DROP_DOWN_OPTIONS = { width: 'auto', minWidth: 220, wrapperAttr: { class: 'ant-quick-create-popup' } };

export default function AntQuickCreateMenu() {
    const appGlobal = AntGlobal();
    const navigate = useNavigate();
    const dropDownRef = useRef(null);
    const msgBox = useRef(null);

    const groups = useMemo(() => {
        if (AntAuth.getWorkspaceMode() !== 'Accounting' || appGlobal.workspaceMode !== 'Accounting') return [];
        const items = AntQuickCreate.visibleItems(appGlobal.accountingQuickCreate);
        return AntQuickCreate.groupItems(items, appGlobal.accountingQuickCreateGroups);
    }, [appGlobal.workspaceMode, appGlobal.accountingQuickCreate, appGlobal.accountingQuickCreateGroups]);

    const onPick = useCallback(
        async (item) => {
            const instance = dropDownRef.current && dropDownRef.current.instance;
            if (instance) instance.close();
            await AntQuickCreate.run(item, navigate, {
                showAlert: (args) => msgBox.current && msgBox.current.show(args)
            });
        },
        [navigate]
    );

    const renderPanel = useCallback(
        () => (
            <div className="ant-quick-create-menu">
                {groups.map((group) => (
                    <div key={group.key} className="ant-quick-create-group">
                        <div className="ant-quick-create-group-title">{String(AntLocalization.translateText(group.text))}</div>
                        {group.items.map((item) => (
                            <div key={item.key} className="ant-quick-create-item dx-item" role="menuitem" tabIndex={0}
                                onClick={() => onPick(item)}
                                onKeyDown={(e) => { if (e.key === 'Enter') onPick(item); }}>
                                {String(AntLocalization.translateText(item.text))}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        ),
        [groups, onPick]
    );

    if (!groups.length) return null;
    return (
        <React.Fragment>
            <DropDownButton
                className="ant-main-header-quick-create"
                icon="add"
                text=""
                hint={String(AntLocalization.translateText(HINT))}
                showArrowIcon={false}
                stylingMode="text"
                focusStateEnabled={false}
                ref={dropDownRef}
                dropDownOptions={DROP_DOWN_OPTIONS}
                dropDownContentRender={renderPanel}
            />
            <AntMessageBox ref={msgBox} />
        </React.Fragment>
    );
}
